export default __webpack_public_path__ + "static/Case Study - USA Clean-2f443bf9b415a8e5cb0dbc55d2e58a8c.pdf";